<template>
  <v-snackbar
      v-if="confirm_request"
      v-model="confirm_request.dialog"
      text
      :color="confirm_request.type"
      transition="scale-transition"
      centered
      :timeout="confirm_request.timeout"
      elevation="10"
      :multi-line="true"
      min-width="600"
  >
    <v-row>
      <v-icon v-if="confirm_request.type === 'error'" :color="confirm_request.type" large>mdi-alert-circle</v-icon>
      <v-icon v-if="confirm_request.type === 'warning'" :color="confirm_request.type" large>mdi-alert-circle-outline</v-icon>
      <v-icon v-if="confirm_request.type === 'info'" :color="confirm_request.type" large>mdi-information-outline</v-icon>
    </v-row>
    <v-row class="px-5 py-5">
      <span v-for="message in confirm_request.message">{{ message }}</span>
    </v-row>
    <v-row>
      <v-spacer></v-spacer>
      <v-btn
          color="grey darken-1"
          text
          @click="confirm_request.dialog = false"
      >
        Cancel
      </v-btn>
      <v-btn
          v-if="confirm_request.type === 'warning'"
          text
          @click="onAgree"
      >
        OK
      </v-btn>
    </v-row>
  </v-snackbar>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {mapFields} from "vuex-map-fields";

let self = '';
export default {
  name: 'TimeTrackerConfirmDialog',

  props: {
    storeName: {type: [String], default: 'TimeTracker'},
  },

  computed: {
    ...mapFields('TimeTracker', ['confirm_request']),
  },

  methods: {
    ...mapActions('TimeTracker', ['fetchRequest']),
    onAgree() {
      console.log('onAgree this.fetchRequest', this.storeName + '/fetchRequest')
      this.confirm_request.request['confirm'] = true
      this.fetchRequest()
      this.confirm_request.dialog = false
    },

  },

  mounted() {
  },

  created() {
  },

  data() {
    return {
    }
  },
}

</script>


<style scoped lang="scss">
</style>